export enum STATUS_COLOURS {
  New = '#06b9b9',
  Approved = '#85ca62',
  Assigned = '#62ca81',
  SM_Review = '#caa162',
  CEO_Review = '#ca62a7',
  QM_Finalise = '#aa62ca',
  Completed = '#606060',
  Rejected = '#ca626f',
}